<template>
  <button
    type="button"
    class="bg-cl-transparent brdr-none flex flex-col middle-xs"
    :class="isOpen ? 'cl-main' : 'cl-light-gray'"
    @click="openSidebarMenuCustom"
    :aria-label="$t('Open menu')"
    data-testid="menuButton"
  >
    <i class="icon-Kafelki-2_mobile h4" />
    <span class="visible-md fs11 sans-serif">Kategorie</span>
  </button>
</template>

<script>
import { mapState } from 'vuex'
import HamburgerIcon from '@vue-storefront/core/compatibility/components/blocks/Header/HamburgerIcon'

export default {
  mixins: [HamburgerIcon],
  computed: {
    ...mapState({
      isAuthElem: state => state.ui.isAuthElem
    })
  },
  methods: {
    openSidebarMenuCustom () {
      if (this.isAuthElem) {
        this.$bus.$emit('modal-hide', 'modal-signup')
      }
      this.$store.commit('ui/setSidebar', !this.isOpen)
    }
  }
}
</script>

<style scoped>
.fs11 {
  font-size: 11px;
}
i {
  height: 20px;
}
</style>
